import { Search, X } from "lucide-react";

type Props = {
  query: string;
  setQuery: (value: string) => void;
  clearFilterQuery: () => void;
};


export default function FilterQuery({ query, setQuery, clearFilterQuery }: Props) {
  return (
    <div className="relative w-full mb-4">
      <input
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        type="search"
        name="query"
        placeholder="Busca por partner, clase"
                    className="w-full px-4 py-2 pr-10 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-holos focus:border-holos"
      />
      <Search className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" />

      {query.length > 0 && (
        <button
          onClick={clearFilterQuery}
          className="absolute right-10 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none cursor-pointer"
        >
          <X />
        </button>
      )}
    </div>
  );
}
